"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metadataSources = void 0;
exports.metadataSources = [
    {
        id: 1,
        microserviceServiceName: "workflowexecutioncontext",
        method: null,
        metadataAssociations: null
    },
    {
        id: 2,
        microserviceServiceName: "patientservice",
        method: "get",
        metadataAssociations: null
    },
    {
        id: 3,
        microserviceServiceName: "encounterservice",
        method: "get",
        metadataAssociations: null
    },
    {
        id: 4,
        microserviceServiceName: "orderservice",
        method: "get",
        metadataAssociations: null
    },
    {
        id: 5,
        microserviceServiceName: "documentservice",
        method: "get",
        metadataAssociations: null
    }
];
//# sourceMappingURL=metadata-sources.js.map